import React from 'react';
import { Outlet } from 'react-router-dom';

const DealRoomCreationRouter: React.FC = () => <Outlet />;

export default DealRoomCreationRouter;
